<template>
    <!-- <AppLayout title="Admins"> -->
         
         
         <v-card class="d-flex flex-column flex-grow-1 table-card overflow-visible" :class="tableCard.card.class" :rounded="tableCard.card.rounded">
             <v-card-text class="d-flex flex-column flex-grow-1" :class="tableCard.card.textClass">
                 <div class="d-flex align-center ga-3 px-3 px-md-0" :class="[tableCard.card.actionPad]">
                     <div class="d-flex flex-grow-1 min-w-0 ga-2 align-center flex-wrap">
                         <div class="w-100 w-md-20rem max-w-100">
                             <v-text-field
                                 v-model="datatable.request.search.value"
                                 :label="tableCard.searchInput.label"
                                 :placeholder="tableCard.searchInput.placeholder"
                                 :density="tableCard.searchInput.density"
                                 :flat="tableCard.searchInput.flat"
                                 :variant="tableCard.searchInput.variant"
                                 :single-line="tableCard.searchInput.singleLine"
                                 :hide-details="true"
                                 @update:model-value="() => datatable.onSearch()"
                                 clearable
                                 :class="[`table-action`, tableCard.searchInput.class]"
                             >
                             <template #prepend-inner >
                                 <span >
                                     <mdi-icon>search</mdi-icon>
                                 </span>
                             </template>
                             </v-text-field>
                         </div>
                         <div class="d-none d-md-block flex-grow-1 flex-grow-sm-0" v-if="page.props.data.filter_has_preview">
                            <v-alert color="bg-secondary" border="start" class="py-2 h-100">
                                <div class="text-no-wrap" v-if="page.props.data.filter_preview?.user">
                                    Admin: <span class="fw-medium">{{ page.props.data.filter_preview?.user }}</span>
                                </div>
                                <div class="text-no-wrap" v-if="page.props.data.filter_preview?.completed">
                                    Completed: <span class="fw-medium">{{ page.props.data.filter_preview?.completed }}</span>
                                </div>
                                
                            </v-alert>
                        </div>
                     </div>
                     <div class="d-flex justify-end ga-2">
                        <div class="dt-filter-open-btn">
                            <div class="d-none d-sm-block">
                                <v-btn-icon text="" class="match-input-compact table-action" color="primary">
                                    <mdi-icon>filter_alt</mdi-icon>
                                    
                                </v-btn-icon>
                            </div>
                            <div class="d-sm-none">
                                <v-btn-icon :color="tableCard.actionMenu.btn.color"  class="match-input-compact table-action" :variant="tableCard.actionMenu.btn.variant">
                                    <mdi-icon :size="tableCard.actionMenu.btn.iconSize">filter_alt</mdi-icon>
                                </v-btn-icon>
                            </div>
                        </div>
                        <v-menu activator=".dt-filter-open-btn" v-model="filterFormOpen" :close-on-content-click="false">
                            <v-sheet color="surface" class="pa-4 max-w-100 w-30rem">
                                <form @submit.prevent="filter" class="d-flex flex-column ga-4">
                                    <div>
                                        <v-select-v1
                                            clearable
                                            label="Completed"
                                            v-model="filterForm.completed"
                                            :items="[
                                                {
                                                    name: 'Yes',
                                                    key: 'yes'
                                                },
                                                {
                                                    name: 'No',
                                                    key: 'no'
                                                }
                                            ]"
                                            item-title="name"
                                            item-value="key"
                                            density="compact"
                                        >
                                            <template v-slot:item="{ props, item }">
                                                <v-list-item v-bind="props" :title="null">
                                                    <div class="fs-n1">{{ item.raw.name }}</div>
                                                </v-list-item>
                                            </template>
                                        </v-select-v1>
                                    </div>
                                    <div>
                                        <v-autocomplete-v1
                                            clearable
                                            label="Admin"
                                            v-model="filterForm.user_id"
                                            :items="page.props.data.admins ?? []"
                                            item-title="name"
                                            item-value="id"
                                            density="compact"
                                        >
                                            <template v-slot:item="{ props, item }">
                                                <v-list-item v-bind="props" :title="null">
                                                    <div class="fs-n1">{{ item.raw.name }} ({{ item.raw.email }})</div>
                                                </v-list-item>
                                            </template>
                                        </v-autocomplete-v1>
                                    </div>
                                    <div class="d-flex justify-end ga-2">
                                        <v-btn type="button" color="btn-secondary" :disabled="filterForm.processing" @click.prevent="clearFilterForm">
                                            clear
                                        </v-btn>
                                        <v-btn type="submit" :loading="filterForm.processing" :disabled="filterForm.processing">
                                            Apply
                                        </v-btn>
                                    </div>
                                </form>
                            </v-sheet>
                        </v-menu>
                         <div class="d-none d-sm-block">
                            <v-btn-input-compact class="table-action">
                                <template #prepend>
                                    <mdi-icon>add</mdi-icon>
                                </template>
                                <span>Make Request</span>
                                <v-menu activator="parent" class="tiny-dropdown">
                                    <v-list>
                                        <Link class="v-list-item-n-link" :href="route('paymentRequests.superadmin.admin.manage', user.id ?? 0)" v-for="user in page.props.data.admins ?? []" :key="user.id ?? 0">
                                            <v-list-item :title="user.email ?? 'Unknown'" :value="`create_payment_request_${user.id ?? 0}`"></v-list-item>
                                        </Link>
                                    </v-list>
                                </v-menu>
                            </v-btn-input-compact>
                         </div>
                         <div class="d-sm-none">
                             <v-btn-icon :color="tableCard.actionMenu.btn.color"  class="match-input-compact table-action" :variant="tableCard.actionMenu.btn.variant">
                                 <mdi-icon :size="tableCard.actionMenu.btn.iconSize">add</mdi-icon>
 
                                 <v-menu activator="parent" class="tiny-dropdown">
                                    <v-list>
                                        <Link class="v-list-item-n-link" :href="route('paymentRequests.superadmin.admin.manage', user.id ?? 0)" v-for="user in page.props.data.admins ?? []" :key="user.id ?? 0">
                                            <v-list-item :title="user.email ?? 'Unknown'" :value="`create_payment_request_${user.id ?? 0}`"></v-list-item>
                                        </Link>
                                    </v-list>
                                </v-menu>
                             </v-btn-icon>
                         </div>
                     </div>
                 </div>
                 <div class="d-md-none pb-3 px-3" v-if="page.props.data.filter_has_preview">
                    <v-alert color="bg-secondary" border="start" class="py-2 h-100">
                        <div class="text-no-wrap" v-if="page.props.data.filter_preview?.user">
                            Admin: <span class="fw-medium">{{ page.props.data.filter_preview?.user }}</span>
                        </div>
                        <div class="text-no-wrap" v-if="page.props.data.filter_preview?.completed">
                            Completed: <span class="fw-medium">{{ page.props.data.filter_preview?.completed }}</span>
                        </div>
                        
                    </v-alert>
                </div>
                 <div class="d-flex-col-grow">
                     <DataTable :datatable="datatable" class="d-flex flex-column has-action"  >
                        <template v-slot:[`item.payment_method`]="{ item }:{item: PaymentRequest}" key="item.payment_method">
                             <div class="fw-medium">{{ item.payment_method_preview?.name }}</div>
                             <div class="fs-n5 font-italic" v-if="item.payment_method == 'crypto' && item.additional_data?.coin">{{ item.additional_data?.coin }}</div>
                         </template>
                         <template v-slot:[`item.completed`]="{ item }:{item: PaymentRequest}" key="item.completed">
                             <div class="text-center">
                                <mdi-icon class="text-success" v-if="item.completed">check</mdi-icon>
                                <mdi-icon class="text-danger" v-else>close</mdi-icon>
                             </div>
                         </template>
                         <template v-slot:[`item.amount`]="{ item }:{item: PaymentRequest}" key="item.amount">
                             <div class="text-no-wrap">
                                <div class="text-no-wrap">
                                {{
                                    helpers.moneyFormatNew(item.amount ?? 0)
                                }}
                            </div>
                            </div>
                         </template>
                         <template v-slot:[`item.action`]="{ item }:{item: PaymentRequest}" key="item.action">
                             <div>
                                 <div class="d-none d-md-block">
                                     <div class="d-flex justify-center">
                                         <v-tooltip text="Show">
                                             <template v-slot:activator="{ props }">
                                                 <Link :href="route('paymentRequests.superadmin.manage', item.id)" v-bind="props">
                                                     <v-btn-icon-text color="primary">
                                                         <mdi-icon>info</mdi-icon>
                                                     </v-btn-icon-text>
                                                 </Link>
                                             </template>
                                         </v-tooltip>
                                         <v-tooltip text="Remove">
                                             <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="danger" v-bind="props" @click.prevent="dialogDeleteForm_Confirm(item)">
                                                    <mdi-icon>delete</mdi-icon>
                                                </v-btn-icon-text>
                                             </template>
                                         </v-tooltip>
                                     </div>
                                 </div>
                                 <div class="d-md-none">
                                     <v-btn-icon :color="tableCard.actionMenu.btn.color" density="compact" variant="plain" >
                                         <mdi-icon>{{ tableCard.actionMenu.btn.icon }}</mdi-icon>
 
                                         <v-menu activator="parent" class="tiny-dropdown">
                                             <v-list min-width="120px" >
                                                 <Link class="v-list-item-n-link" :href="route('paymentRequests.superadmin.manage', item.id)">
                                                     <v-list-item title="Show" value="edit_paymentRequests">
                                                         <template #prepend>
                                                             <mdi-icon>info</mdi-icon>
                                                         </template>
                                                     </v-list-item>
                                                 </Link>
                                                <v-list-item title="Remove" value="sent_document"  @click.prevent="dialogDeleteForm_Confirm(item)">
                                                    <template #prepend>
                                                        <mdi-icon>delete</mdi-icon>
                                                    </template>
                                                </v-list-item>
                                             </v-list>
                                         </v-menu>
                                     </v-btn-icon>
                                 </div>
                             </div>
                             
                         </template>
                     </DataTable>
                 </div>
                 
                 
             </v-card-text>
         </v-card>
         
         <v-dialog v-model="dialogDeleteForm.show" width="auto" @afterLeave="dialogDeleteForm_Close">
            <v-card max-width="100%" width="500">
                <v-card-title>Remove request</v-card-title>
                <v-card-subtitle>Are you sure you want to remove this request?</v-card-subtitle>
                <v-card-text class="py-2">
                    <div v-if="dialogDeleteForm.errors.custom_error" class="text-error">{{ dialogDeleteForm.errors.custom_error }}</div>
                </v-card-text>
                <v-card-actions-modal>
                    <v-btn
                        text="No"
                        color="btn-secondary"
                        @click="dialogDeleteForm_Close"
                    ></v-btn>
                    <v-btn
                        :disabled="dialogDeleteForm.processing"
                        :loading="dialogDeleteForm.processing"
                        @click="dialogDeleteForm_Submit"
                        color="error"
                        text="Remove"
                    ></v-btn>
                </v-card-actions-modal>
            </v-card>
        </v-dialog>
    <!-- </AppLayout> -->
 </template>
 <script setup lang="ts">
    import { ref } from "vue";
    import { Page, GlobalEventCallback } from '@inertiajs/core';
    import { usePage, Link, useForm } from '@inertiajs/vue3';
    import { SharedPageProps } from '@/Types/inertia';
    import { PaymentRequest } from '@/Types/Models/payment-request';
    import { useDatatable, TableResponse } from '@/Composables/Datatable';
    import { toast } from "vue3-toastify";
    import { pageTitle, useTableCard, containerGapForTable } from '@/Composables/PageMeta';
    import DataTable from '@/Components/vuetify/DataTable.vue';
    import helpers from '@/Plugins/helpers';
import { User } from "@/Types/Models/user";

    containerGapForTable();
    type PageData = SharedPageProps & {
        data:{
            table?: TableResponse<PaymentRequest>;
            admins?: User[],
            filter:{
                completed: 'yes' | 'no' | null,
                user_id: number | null,
            };
            filter_preview: {
                completed?: string,
                user?: string,
            };
            filter_has_preview: boolean;
        };
    }
    const page = usePage<PageData>();
    pageTitle.value = 'Payment Requests';
    const datatable = useDatatable<PaymentRequest>(route('paymentRequests.superadmin.index'), page.props.data.table, {
        additionalFilters:{
            completed: page.props.data.filter.completed ?? null,
            user_id: page.props.data.filter.user_id ?? null,
        }
    });
    console.log(datatable.request.length)

    const tableCard = useTableCard();
    
    const dialogDeleteForm = useForm<{
        show: boolean,
        item: PaymentRequest | null,
        custom_error: string,
    }>({
        show: false,
        item: null,
        custom_error: '',
    });
    const dialogDeleteForm_Confirm = (item: PaymentRequest) => {
        dialogDeleteForm.reset();
        dialogDeleteForm.clearErrors();
        dialogDeleteForm.item = item;
        dialogDeleteForm.show = true;
    }
    const dialogDeleteForm_Close = () => {
        dialogDeleteForm.reset();
        dialogDeleteForm.clearErrors();
    }
    const dialogDeleteForm_Submit = () => {
        dialogDeleteForm.transform((data) => ({
            custom_error: data.custom_error
        })).delete(route('paymentRequests.superadmin.delete', dialogDeleteForm.item?.id), {
            preserveScroll: true,
            onSuccess: ((page: Page<PageData>) => {
                dialogDeleteForm_Close();
                toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Payment request is removed');
                datatable.setTable(page.props.data.table);
            }) as GlobalEventCallback<"success">,
        });
    }

    const filterFormOpen = ref(false);
    
    const filterForm = useForm<{
        completed: 'yes' | 'no' | null,
        user_id: number | null
    }>({
        completed: null,
        user_id: null,
    });
    filterForm.completed = page.props.data.filter.completed ?? null;
    filterForm.user_id = page.props.data.filter.user_id ?? null;
    const clearFilterForm = () => {
        filterForm.reset();
        filterForm.clearErrors();
        filter();
    }
    const filter = () => {
        datatable.request.additionalFilters.completed = filterForm.completed;
        datatable.request.additionalFilters.user_id = filterForm.user_id;
        datatable.onSearch();
        filterFormOpen.value = false;
    }
 </script>